import { context } from '@client/context';
import Functions from '@client/style/Functions';
import { useAuthenticatedUser } from '@client/utils/AuthStore';
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import Image, { ImageData } from '@client/modules/Image';
import { Breakpoints, Colors } from '@client/style/Variables';
import Site from '@client/store/Site';

const Container = styled.div<{ $bg?: string }>`
	position: relative;
	background-color: ${props => props.$bg || '#E8C8E1'};
	padding-top: 100px;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;

	&:has(+ .BreakerModule) {
		padding-bottom: var(--breaker-total);
	}
`;

const ImageWrapper = styled.div`
	position: relative;
	width: 100%;
	max-width: 1280px;
	display: flex;
	flex-wrap: nowrap;
	justify-content: start;
	padding-left: 5vw;
	margin-bottom: 1em;

	${Functions.breakpoint(Breakpoints.mobile)} {
		padding-left: 0;
		margin-bottom: 1em;
		justify-content: center;
	}
`;

const StyledImage = styled(Image)<{ $ratio?: number }>`
	aspect-ratio: ${props => props.$ratio};
	flex: 1 0 120vw;
	max-width: 38.75em;

	${Functions.breakpoint(Breakpoints.laptop)} {
		// margin-right: 15vw;
		max-width: 45em;
	}
`;

interface IProps {
	data: {
		checkoutUrl: string;
		backgroundColorLink?: any;
		buttonsColorLink?: any;
		headerAsset?: ImageData;
	};
}

export const StoreModule = (props: IProps) => {
	const user = useAuthenticatedUser();
	const preoSdkId = Site.use(state => state.server.preoSdkId);

	const preoRef = useRef<Element>(null);

	useEffect(() => {
		// console.log('preoRef : ', preoRef);

		if (!preoRef.current) return;

		// console.log('Ref is set');

		const onPreoEvent = (e: any) => {
			console.dir(e);

			if (e.type === 'onSsoLogin') {
				context.auth.signIn(true);
			}
		};

		preoRef.current.addEventListener('onSsoLogin', onPreoEvent);

		return () => {
			preoRef.current?.removeEventListener('onSsoLogin', onPreoEvent);
		};
	}, [preoRef]);

	return (
		<Container $bg={props.data.backgroundColorLink?.color} className='colorWrapperAnimatedModule'>
			{props.data.headerAsset && (
				<ImageWrapper>
					<StyledImage
						data={props.data.headerAsset}
						maxWidth={2500}
						minWidth={800}
						$ratio={props.data.headerAsset.width / props.data.headerAsset.height}
					/>
				</ImageWrapper>
			)}
			<preo-storefront
				ref={preoRef}
				sdk-id={preoSdkId ?? ''}
				auth-method='sso'
				auth-user-first-name={user?.userInfo?.given_name}
				auth-user-last-name={user?.userInfo?.family_name}
				auth-user-phone={user?.userInfo?.extension_MobilePhone}
				auth-user-email={user?.userInfo?.emails.length ? user?.userInfo?.emails[0] : undefined}
				checkout-success-url={props.data.checkoutUrl}
				checkout-cancel-url={props.data.checkoutUrl}
				age-gate-mode='on_cart_add'
				is-catalogue='true'
				sticky-summary='true'
				color-brand={props.data.buttonsColorLink?.color}
				color-text-button={props.data.buttonsColorLink?.contrastColor}
				color-text-footer={Colors.darkBackground}
			/>
			<script src='https://cdn.jsdelivr.net/npm/@preo-live/components@0.6/dist/components.umd.js'></script>
		</Container>
	);
};
